<template>
  <v-card class="fill-height" flat tile>
    <v-card-title class="text-center">
      Масса с учётом коэффициента запаса, т
    </v-card-title>
    <v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="cell in components" :key="cell.COMP_ID">
              {{cell.COMP_NAME}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td v-for="val in massValues" :key="val.ID">
              <v-text-field v-model="val.VAL" dense></v-text-field>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
  </v-card>
</template>

<script>
import { UI_ADD_ACTION, UI_SET_ACTIONS } from '@/store/actions/ui'

export default {
  name: 'rcptCompMassCard',
  components: {},
  props: {
    components: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      massValues: []
    }
  },
  computed: {},
  watch: {
    components (val) {
      console.log('components changed to ', val)
      this.massValues.splice(0, this.massValues.length)
      this.components.forEach((item) => { this.massValues.push({ ID: item.COMP_ID, VAL: item.COMP_Q || 0 }) }, this)
    },
    component (val) {
      console.log('compPropertiesCard - component changed to ', val)
      this.setActions()
    },
    currentProperty (val) {
      console.log('compPropertiesCard - currentProperty changed to ', val)
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Свойства компонента',
        actions: []
      })
      if (this.activeTab === 'tabComponents') {
        // if (this.component && this.component.COMP_ID) { this.$store.dispatch(UI_ADD_ACTION, this.addProperty) }
        if (this.currentProperty.length > 0) {
          this.$store.dispatch(UI_ADD_ACTION, this.editProperty)
          // this.$store.dispatch(UI_ADD_ACTION, this.delProperty)
        }
      }
    },
    addComponentProp () {
      this.currentProperty.splice(this.currentProperty, 1)
      this.showAddComponentPropDialog = true
    },
    updComponentProp () {
      this.showAddComponentPropDialog = true
    },
    showDelDialog () {
      console.log('Calling for confirm dialog')
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    onComponentPropertyAdded (data) {
      this.currentProperty.splice(0, 1, data)
      this.showAddComponentPropDialog = false
    }
  },
  mounted () {
    // this.setActions()
  },
  created () {
  }
}
</script>

<style scoped>

</style>
